import { Text, ButtonIcon } from '@cubeyou-team/hx-react-components';
import React, { FC, useCallback, useState } from 'react';
import styled from 'styled-components';

import { useAudienceActivationContext } from 'src/modules/audience-activation/providers/AudienceActivationProvider';
import { MODAL_TYPES } from 'src/components/RepositoryItemActions/constants';
import { DestinationImage } from '../../DestinationImage';

interface SelectedDestinationCardProps {
  destination: string;
  image: string;
  title: string;
  isSelected: boolean;
  onDelete: (id: string) => void;
  onEdit: (id: string) => void;
}

const StyledContainer = styled.div`
  width: 105px;
  height: 103px;
  position: relative;
`;

const StyledActionDiv = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 1rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid #d8d7ea;
  background-color: ${props => props.theme.colors.dark_light};
  opacity: 0.6;
`;

const StyledSelectedDestinationCard = styled.button`
  padding: 1rem 0.5rem;
  width: 105px;
  height: 103px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 0.25rem;
  border: 1px solid #d8d7ea;

  background-color: #fff;

  .image {
    width: 2.5rem;
    height: 2.75rem;
  }

  .title {
    display: flex;
    align-items: center;
    height: 2.8em;
    line-height: 0.75rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SelectedDestinationCard: FC<SelectedDestinationCardProps> = ({
  destination,
  image: icon,
  title = 'Not Available',
  onDelete,
  onEdit,
}) => {
  const { modalType } = useAudienceActivationContext();
  const [hovered, setHovered] = useState<boolean>(false);

  const onFocus = useCallback(() => {
    if (modalType !== MODAL_TYPES.OPEN_CAMPAIGN) setHovered(true);
  }, [modalType]);

  const onBlur = useCallback(() => setHovered(false), []);

  return (
    <StyledContainer onMouseEnter={onFocus} onMouseLeave={onBlur}>
      <StyledSelectedDestinationCard>
        <DestinationImage src={icon} alt={title} />
        <Text size="xsmall" align="center" className="title">
          {title}
        </Text>
      </StyledSelectedDestinationCard>
      {hovered && (
        <StyledActionDiv>
          <ButtonIcon
            icon="delete"
            size="medium"
            variant="light"
            onClick={() => onDelete(destination)}
          />
          <ButtonIcon
            icon="edit"
            size="medium"
            variant="light"
            onClick={() => onEdit(destination)}
          />
        </StyledActionDiv>
      )}
    </StyledContainer>
  );
};
